import { BiometricEligibility, InitialData } from '../../model'

export interface BiometricEligibilityParams {
  browserCanSupportBiometric: boolean
  isAuthenticatorAvailable: boolean
  initialData: InitialData
}

export const createBiometricEligibilityPayload = (params: BiometricEligibilityParams): BiometricEligibility => {
  const { browserCanSupportBiometric, isAuthenticatorAvailable, initialData } = params

  return {
    isBiometricCapableBrowser: browserCanSupportBiometric,
    isLoggedInWithOAuth: false,
    oAuthState: {
      clientId: initialData.clientId,
      responseType: initialData.responseType,
      redirectUri: initialData.redirectUri,
      scope: initialData.scope,
      consumerEmailId: null,
    },
    isUserVerifyAuthenticatorAvailable: isAuthenticatorAvailable,
  }
}
